"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var AutoBillPayState_1 = require("./AutoBillPayState");
var styles = require("./AutoBillPay.scss");
var ReportingService_1 = require("../../../../api/ReportingService");
var CartUtilFunctions_1 = require("../../../../utils/CartUtilFunctions");
var UtilityFunctions_1 = require("../../../../utils/UtilityFunctions");
var components_1 = require("@idp/duc/components");
var utils_1 = require("@idp/ui-components/utils");
var ui_components_1 = require("@idp/ui-components");
var PriceContainerProps_1 = require("@idp/ui-components/components/cards/PriceContainer/PriceContainerProps");
var Api_1 = require("../../../../api/Api");
var StateProvider_1 = require("../../../../api/StateProvider");
var cartUtils = require("../../../../utils/CartUtilFunctions");
var wlsUtils = require("../../../../utils/WirelessUtilFunctions");
var wirelessCms = wlsUtils.getWlsCmsData();
var AutoBillPay = /** @class */ (function (_super) {
    __extends(AutoBillPay, _super);
    function AutoBillPay(props) {
        var _this = _super.call(this, props) || this;
        _this.isAutoBillPayChecked = false;
        _this.reportingService = new ReportingService_1.default();
        _this.state = new AutoBillPayState_1.AutoBillPayState();
        _this.api = new Api_1.default();
        _this.stateManager = StateProvider_1.StateProvider.getStateManagerInstance();
        _this.expandAndCollapse = _this.expandAndCollapse.bind(_this);
        _this.showAutoPayExpandedView = _this.showAutoPayExpandedView.bind(_this);
        _this.handleAutoBillPayClick = _this.handleAutoBillPayClick.bind(_this);
        return _this;
    }
    AutoBillPay.prototype.componentDidMount = function () {
        if (cartUtils.isMobileUserAgent() || UtilityFunctions_1.isMobile() || !this.props.autoPaySelected) {
            this.setState({ isExpandedView: false });
        }
        else {
            this.setState({ isExpandedView: true });
        }
    };
    AutoBillPay.prototype.render = function () {
        var _this = this;
        var _a;
        var autoPayText = this.props.autoPaySelected ?
            wirelessCms.preSelectedAutoPayText : wirelessCms.nonPreSelectedAutoPayText;
        this.isAutoBillPayChecked = this.props && this.props.autoPaySelected;
        return (React.createElement("section", null,
            React.createElement("div", { className: styles.panelContent },
                React.createElement("div", { className: styles.titleContainer },
                    React.createElement("div", { className: styles.title },
                        React.createElement("h3", { className: styles.titleText },
                            " ",
                            wirelessCms.autoBillPayHeading,
                            " ")),
                    React.createElement("div", null,
                        React.createElement(components_1.Link, { "aria-label": this.state.isExpandedView ? 'Collapse AutoBillPay Panel' : 'Expand AutoBillPay Panel', kind: "withPrependIcon", testId: utils_1.default('Wireless', 'Auto Bill Pay'), 
                            // tslint:disable-next-line: jsx-no-lambda
                            onClick: function () { _this.expandAndCollapse(); }, icon: this.state.isExpandedView ?
                                React.createElement(components_1.IconSvg, { size: 16, svgNodeStr: UtilityFunctions_1.GET_ICON_SVG.UP }) :
                                React.createElement(components_1.IconSvg, { size: 16, svgNodeStr: UtilityFunctions_1.GET_ICON_SVG.DOWN }) }))),
                !this.state.isExpandedView &&
                    React.createElement("div", { className: styles.autopaySubtext },
                        React.createElement(ui_components_1.RichText, { testId: utils_1.default('Wireless', 'Label', 'AutoPay'), data: { text: autoPayText === null || autoPayText === void 0 ? void 0 : autoPayText.replace('(0)', (_a = this.props.autoPayAmount) === null || _a === void 0 ? void 0 : _a.toString()) } }))),
            this.showAutoPayExpandedView()));
    };
    AutoBillPay.prototype.expandAndCollapse = function () {
        this.setState({ isExpandedView: !this.state.isExpandedView });
        this.reportingService.fireLinkClickWithOutPageLoad(wirelessCms.autoBillPayHeading, CartUtilFunctions_1.getLinkClickBasekUrl());
    };
    AutoBillPay.prototype.showAutoPayExpandedView = function () {
        var _this = this;
        var _a;
        if (this.state.isExpandedView) {
            return (React.createElement(React.Fragment, null,
                React.createElement("section", null,
                    React.createElement("div", { className: styles.autopayBox },
                        React.createElement(components_1.CardShell, { type: "radio", isChecked: this.isAutoBillPayChecked ? true : false, tabIndex: 0, withSelectedBg: true, 
                            // tslint:disable-next-line: jsx-no-lambda
                            onClick: function () { return _this.handleAutoBillPayClick(true); } },
                            React.createElement("div", { className: styles.autopayItem },
                                React.createElement("div", { className: styles.boxContent },
                                    wirelessCms.autoBillPayText,
                                    " \u00A0"),
                                React.createElement("div", { className: styles.autopayPrice },
                                    React.createElement(ui_components_1.PriceContainer, { testId: 'AutoPay_Price', data: { billingNote: '/mo', price: this.props.autoPayAmount }, options: {
                                            accessibility: "dollar " + this.props.autoPayAmount + " per line",
                                            decimalPoints: 2, isDataPriceNegative: true,
                                            overrideAccessibility: true, type: PriceContainerProps_1.PricingType.XSMALL,
                                        } }))),
                            React.createElement("div", null,
                                React.createElement("div", { className: styles.divider }),
                                React.createElement("span", { className: styles.autopayDetails }, (_a = wirelessCms.autoBillPayDetails) === null || _a === void 0 ? void 0 : _a.replace('(0)', '10')),
                                "\u00A0")),
                        React.createElement(components_1.CardShell, { type: "radio", isChecked: this.isAutoBillPayChecked ? false : true, className: styles.autopayItem, tabIndex: 0, withSelectedBg: true, 
                            // tslint:disable-next-line: jsx-no-lambda
                            onClick: function () { return _this.handleAutoBillPayClick(false); } },
                            React.createElement("div", { className: [styles.boxContent, styles.boxWidth].join(' ') },
                                React.createElement(ui_components_1.RichText, { testId: utils_1.default('Wireless', 'AutoPay'), data: { isDecodingRequired: false, text: wirelessCms.noAutoBillPay } })))))));
        }
        else {
            return '';
        }
    };
    AutoBillPay.prototype.buildEnrollmentReq = function (autobillPayChecked) {
        var lobTypes = UtilityFunctions_1.getCurrentLOBList();
        var autobillPayenrollItem = {
            enrolled: autobillPayChecked,
            type: 'autoBillPay',
        };
        var eBillPayenrollItem = {
            enrolled: true,
            type: 'eBill',
        };
        var autoBillPayRequest = {
            enrollments: [autobillPayenrollItem, eBillPayenrollItem],
            lobTypes: lobTypes,
        };
        return autoBillPayRequest;
    };
    AutoBillPay.prototype.handleAutoBillPayClick = function (isAutoBillPaySelected) {
        var _this = this;
        if (isAutoBillPaySelected) {
            this.setState({ isExpandedView: true });
        }
        else {
            this.setState({ isExpandedView: false });
        }
        if (this.props.autoPaySelected !== isAutoBillPaySelected) {
            var autoPayText = isAutoBillPaySelected ? wirelessCms.autoBillPayText : wirelessCms.noAutoBillPay;
            this.reportingService.fireLinkClickWithOutPageLoad(autoPayText, CartUtilFunctions_1.getLinkClickBasekUrl());
            this.props.events.doLoading(true);
            var buildReq = this.buildEnrollmentReq(isAutoBillPaySelected);
            this.api.autobillPay(buildReq).then(function (data) {
                _this.props.events.doLoading(false);
                if (data && data.content && data.content.payload &&
                    data.content.status.toUpperCase() === 'SUCCESS' &&
                    (data.content.payload.addedPromotions.length > 0 ||
                        data.content.payload.removedPromotions.length > 0)) {
                    _this.stateManager.set('cartUpdate', { cartRefresh: true });
                }
            }).catch(function (error) {
                _this.props.events.doLoading(false);
                _this.setState({ isExpandedView: false });
            });
        }
    };
    return AutoBillPay;
}(React.Component));
exports.default = AutoBillPay;
//# sourceMappingURL=AutoBillPay.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/CartLob/WirelessCart/AutoBillPay/AutoBillPay.js
// module id = 776
// module chunks = 8